import Header from './header';
import EnterpriseThankYouBody from './body';
import EnterpriseThankYouFooter from './footer';
import BackgroundThemeWrapper from './background';

export { Header, EnterpriseThankYouBody, EnterpriseThankYouFooter, BackgroundThemeWrapper };
